var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9688 20.9422H8.87817V25.5644H54.9688V20.9422Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4301 23.84L55.8541 23.3991C55.2354 22.9262 55.111 22.0444 55.5768 21.4222L56.0141 20.8356C56.7252 19.9004 56.4123 18.752 55.5946 17.7884L49.6355 9.44356C48.7395 8.18844 47.2923 7.44178 45.7492 7.44178H18.2328C16.6897 7.44178 15.2426 8.18844 14.3466 9.44356L8.40167 17.7884C7.58389 18.752 7.27456 19.8969 7.98212 20.8356L8.41945 21.4222C8.88167 22.048 8.76078 22.9262 8.14212 23.3991L7.56612 23.84C6.63101 24.5511 6.44612 25.8844 7.15723 26.8196L28.0994 55.9787C28.4123 56.3876 28.8959 56.6293 29.4115 56.6293H34.5777C35.0932 56.6293 35.5768 56.3876 35.8897 55.9787L56.8426 26.8196C57.5537 25.8844 57.3688 24.5476 56.4337 23.84H56.4301ZM32.4657 52.3982C32.2274 52.7111 31.7581 52.7111 31.5199 52.3982L10.5706 23.6729C10.3323 23.36 10.4106 22.9049 10.6417 22.5956L17.2657 13.312C17.8239 12.5262 18.727 12.064 19.6906 12.064H44.2915C45.255 12.064 46.1581 12.5298 46.7163 13.312L53.351 22.5956C53.5857 22.9049 53.6603 23.3636 53.4221 23.6729L32.4621 52.3982H32.4657Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftLight);
export default __webpack_public_path__ + "static/media/nft-light.1392cc25f495fa9be97658793e2be87e.svg";
export { ForwardRef as ReactComponent };